<style lang="less" scoped>
  .preview-box{
    margin-top: 20px;
    border-radius: 5px;
    border: 1px solid #eee;
    box-shadow: 2px 2px 5px #f0f0f0;
    padding: 10px;
  }
</style>

<template>
  <div>
    <div class="preview-box" ref="box" v-show="file">
      <slot></slot>
      <canvas ref="canvas"></canvas>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    file: {
      type: File,
      required: false
    }
  },
  watch: {
    file(v) {
      let canvas = this.$refs.canvas;
      if (!v) {
        let { width, height } = canvas;
        canvas.getContext("2d").clearRect(0, 0, width, height);
        this.$emit("update", { width, height, canvas });
        return;
      }
      let img = document.createElement("img");
      img.src = URL.createObjectURL(v);
      img.addEventListener("load", () => {
        let { width, height } = img;
        let _limitWidth =  (document.documentElement.clientWidth - 320)/2;
        canvas.width = width>_limitWidth?_limitWidth:width;
        canvas.height = width>_limitWidth?height/width*_limitWidth:height;
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        this.$refs.box.style.width = canvas.width + 'px';
        let percent = width / _limitWidth
        this.$emit("update", { width, height, file: v, canvas, percent});
      });
    }
  }
};
</script>

